
export enum EPnP {
    "SOURCE" = "KIVI"
  }